import { mapToCanActivate, Routes } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { EmployeeDetailComponent } from './components/employee-detail/employee-detail.component';
import { EmployeeItemComponent } from './components/employee-item/employee-item.component';
import { EmployeeOverviewComponent } from './components/employee-overview/employee-overview.component';
import { EmployeeRelationCreateComponent } from './components/employee-relation-create/employee-relation-create.component';
import { EmployeeRelationsComponent } from './components/employee-relations/employee-relations.component';
import { EmployeeComponent } from './employee.component';
import { EmployeeTenantGuard } from './guards/employee-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: EmployeeOverviewComponent,
    data: { name: 'employee-overview', pageTitle: 'app.employee.module' },
  },
  {
    path: ':employeeId',
    component: EmployeeItemComponent,
    children: [
      {
        path: '',
        component: EmployeeDetailComponent,
        data: { name: 'employee-detail' },
      },
      {
        path: 'relations',
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: EmployeeRelationsComponent,
            data: { name: 'employee-relations' },
          },
          {
            path: 'add',
            component: EmployeeRelationCreateComponent,
            data: { name: 'employee-relations-add' },
          },
        ],
      },
    ],
  },
];

export const employeeRoutes: Routes = [
  {
    path: 'employees',
    component: EmployeeComponent,
    canActivate: mapToCanActivate([AuthGuard, EmployeeTenantGuard]),
    children: routes,
  },
];
